///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { useDispatch } from "react-redux";

import SimpleCell from "./SimpleCell";

export const ButtonCell = ({
  column,
  rowIndex,
  cellIndex,
  value,
  analyticsGridView,
  defaultIndex,
  selectedButtonIndex
}) => {
  const dispatch = useDispatch();
  const { buttonClick } = column;

  return (
    <SimpleCell
      cellDetails={column}
      rowIndex={rowIndex}
      cellIndex={cellIndex}
      analyticsGridView={analyticsGridView}
    >
      <button
        className={`button-cell ${
          selectedButtonIndex === defaultIndex ? "selected-button-cell" : ""
        }`}
        id={rowIndex + "_" + cellIndex}
        onClick={e => {
          e.stopPropagation();
          buttonClick &&
            dispatch(
              buttonClick({
                defaultIndex,
                analyticsGridView
              })
            );
        }}
      >
        {value}
      </button>
    </SimpleCell>
  );
};

export default ButtonCell;
